import { Platform } from 'react-native';
export function restrictValueInRange(start = 0, end = 0, value = 0) {
    return Math.min(Math.max(start, value), end);
}
export function getLastMatchedThreshold(value, thresholds) {
    let matchedThreshold = 0;
    for (let i = 0; i < thresholds.length; i += 1) {
        if (value >= thresholds[i]) {
            matchedThreshold = thresholds[i];
        }
    }
    return matchedThreshold;
}
// web 工具方法
function isWindow(obj) {
    const toString = Object.prototype.toString.call(obj);
    return (toString == '[object global]' ||
        toString == '[object Window]' ||
        toString == '[object DOMWindow]');
}
export function checkIntersectionObserver() {
    if (Platform.OS === 'web' &&
        'IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
        // Minimal polyfill for Edge 15's lack of `isIntersecting`
        // See: https://github.com/w3c/IntersectionObserver/issues/211
        if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
            Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
                get: function () {
                    return this.intersectionRatio > 0;
                },
            });
        }
        return true;
    }
    return false;
}
// 滚动元素是window的判断方法
export const checkIsInScrollWindow = (boundingRect) => {
    const rect = boundingRect || {};
    const vWidth = window.innerWidth || document.documentElement.clientWidth;
    const vHeight = window.innerHeight || document.documentElement.clientHeight;
    if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight) {
        return false;
    }
    return true;
};
export const checkIsInScrollEle = (boundingRect, scrollEle) => {
    const rect = boundingRect || {};
    const scrollEleRect = (scrollEle === null || scrollEle === void 0 ? void 0 : scrollEle.getBoundingClientRect()) || {};
    if (rect.right < scrollEleRect.left ||
        rect.bottom < scrollEleRect.top ||
        rect.left > scrollEleRect.left + scrollEleRect.width ||
        rect.top > scrollEleRect.top + scrollEleRect.height) {
        return false;
    }
    return true;
};
// 判断元素是否在视口内
export const checkIsInViewWithBoundingRect = (boundingRect, scrollEle) => {
    return isWindow(scrollEle)
        ? checkIsInScrollWindow(boundingRect)
        : checkIsInScrollEle(boundingRect, scrollEle);
};
const style = (el, prop) => {
    var _a;
    return typeof getComputedStyle !== 'undefined'
        ? getComputedStyle(el, null).getPropertyValue(prop)
        : // @ts-ignore
            (_a = el.style) === null || _a === void 0 ? void 0 : _a[prop];
};
const overflow = (el) => {
    return style(el, 'overflow') + style(el, 'overflow-y') + style(el, 'overflow-x');
};
export const getScrollParent = (el) => {
    if (!(el instanceof HTMLElement)) {
        return window;
    }
    let parent = el;
    while (parent) {
        if (parent === document.body || parent === document.documentElement) {
            break;
        }
        if (!parent.parentNode) {
            break;
        }
        if (/(scroll|auto)/.test(overflow(parent))) {
            return parent;
        }
        parent = parent.parentNode;
    }
    return window;
};
